import { NavLink } from "react-router-dom";
import { LayoutDashboard, CalendarDays, HeartPulse, Sparkles, BookOpen } from "lucide-react";

const items = [
  { to: "/portal", label: "Home", Icon: LayoutDashboard, end: true },
  { to: "/portal/schedule", label: "Schedule", Icon: CalendarDays },
  { to: "/portal/log", label: "Log", Icon: HeartPulse },
  { to: "/portal/journal", label: "Journal", Icon: BookOpen },
  { to: "/portal/program", label: "Program", Icon: Sparkles },
];

export default function PortalNav() {
  return (
    <nav className="tab-bar" data-testid="portal-tab-bar">
      {items.map(({ to, label, Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => (isActive ? "active" : "")}
          data-testid={`tab-${label.toLowerCase()}`}
        >
          <Icon size={18} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
